/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest, select } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { refreshTokens } from 'modules/common/utils/refresh-token';
import { selectRefreshToken } from 'modules/common/auth/selectors';
import { authActions } from 'modules/common/auth/slice';
import API from 'modules/common/auth/constants';

export function* authFetchUserGenerator({ payload: { userId } }) {
  try {
    const response = yield call(request, API.POST_FETCH_USER, { userId }, true);
    yield put(authActions.fetchUserSucceeded(response));
  } catch (err) {
    yield put(authActions.fetchUserFailed('User request failed'));
  }
}
//
export function* authSignOutUserGenerator() {
  try {
    const refreshToken = yield select(selectRefreshToken);
    const response = yield call(request, API.POST_SIGN_OUT, { refreshToken: refreshToken ?? '' });
    yield put(authActions.signOutSucceeded(response));
  } catch (err) {
    yield put(authActions.signOutFailed(err?.message));
  }
}
//
export function* refreshAuthTokens() {
  try {
    yield call(refreshTokens);
  } catch {
    // refreshTokens already updates auth failure and session-timeout state.
  }
}
//
export function* authSaga() {
  yield takeLatest(authActions.fetchUser.type, authFetchUserGenerator);
  yield takeLatest(authActions.signOut.type, authSignOutUserGenerator);
  yield takeLatest(authActions.refreshToken.type, refreshAuthTokens);
}
export default authSaga;
